import { render, staticRenderFns } from "./IndexBlog.vue?vue&type=template&id=22400148&scoped=true&"
import script from "./IndexBlog.vue?vue&type=script&lang=js&"
export * from "./IndexBlog.vue?vue&type=script&lang=js&"
import style0 from "./IndexBlog.vue?vue&type=style&index=0&id=22400148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22400148",
  null
  
)

export default component.exports